import { Snackbar } from "@material-ui/core";
import React from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

function AlertMessage({ open, message, setOpen ,severity}) {
  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen({ open: false });
  };
  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        onClose={handleClose}
        key={{ vertical: "top", horizontal: "center" }}
        style={{ zIndex: 19999 }}
        autoHideDuration={3000}
      >
        <Alert onClose={handleClose} severity={severity?"success":"error"}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default AlertMessage;
